import PropTypes from 'prop-types';

/**
 * Authenticated user interface shape for PropTypes validation
 */
export const AuthShape = PropTypes.shape({
  jwt: PropTypes.string,
  accountId: PropTypes.string,
  userId: PropTypes.string,
});

export default AuthShape;
